/* eslint-disable no-unused-vars */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'utils/moment';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack';
import Panel from '../../../components/panel';
import Loading from '../../../components/loading';
import icon from '../../../icons/Non_Airfield_WorkOrder.png';
import {
  WORKORDER_STATUS_NEW,
  WORKORDER_STATUS_INPROGRESS,
  WORKORDER_STATUS_CLOSED
} from '../../../constants/ModelStatus';
import { getLeaseWorkorder, fetchWorkOrderSchema, createLeaseMaintenance, clearMaintenance } from '../redux/actions';
import WorkorderInfo from './components/WorkorderInfo';
import { GetFileName, S3Uploads } from '../../services';
import styles from '../../workorders/Detail/workOrderDetail.module.scss';
import customStyles from '../../../components/customFields/customField.module.scss';
import Status from '../List/components/Status';
import MaintenanceReview from './components/MaintenanceReview';
import OperationReview from './components/OperationReview';


class MaintenanceDetail extends Component {
    state = {
      maintenance: {
        attachments: [],
        completed_on: moment().format(),
        work_description: '',
        completed_by: {}
      },
      showFormErrors: false,
      requiredMap: {},
      answers: {},
      fieldErrors: {
        completed_by: false,
        completed_on: false,
        work_description: true
      },
      loadingStatus: false
    }

    firstTime = true;

    componentDidMount() {
      const { actionFetchWorkorder, actionGetSchemas, match: { params: { id } } } = this.props;
      actionFetchWorkorder(id);
      actionGetSchemas();
    }

    static getDerivedStateFromProps(props, state) {
      // grab user from state
      if (props.user.id && !state.maintenance.completed_by.id) {
        return { ...state,
          maintenance: {
            ...state.maintenance,
            completed_by: {
              id: props.user.id,
              fullname: props.user.fullname
            }
          }
        };
      }
      if (props.MaintenanceAction && props.MaintenanceAction.success && state.loadingStatus) {
        props.history.push('/maintenance');
        return { loadingStatus: false };
      }
      return state;
    }

    componentDidUpdate() {
      const { leaseMaintenance_schema, leaseWorkorder } = this.props;
      if (!this.firstTime || (leaseWorkorder && !Object.keys(leaseWorkorder).length)
        || (leaseMaintenance_schema === undefined)) return;
      const sch = leaseMaintenance_schema.maintenance;

      this.processInspectionForState(sch);
      this.firstTime = false;
    }

    componentWillUnmount() {
      const { actionClear } = this.props;
      actionClear();
    }

    processInspectionForState = (sectionschema) => {
      if (sectionschema) {
        const { schema } = sectionschema;
        let { fieldErrors, requiredMap } = this.state;
        schema.fields.forEach((f) => {
          requiredMap = { ...requiredMap, [f.id]: f.required };
          fieldErrors = { ...fieldErrors, [f.id]: f.required };
        });
        this.setState({ requiredMap, fieldErrors });
      }
    }

    handleSearchForUser = (value) => {
      clearTimeout(this.timeout);
    }

    handleAnswerChanged = (type, answer, fieldId) => {
      this.setState(prevState => ({
        [type]: {
          ...prevState[type],
          [fieldId]: answer
        }
      }));
    }

    handleFieldErrorChanged = (id, value) => {
      this.setState(prevState => ({
        fieldErrors: {
          ...prevState.fieldErrors,
          [id]: value
        }
      }));
    }

    getFileNames = async (count) => {
      const response = await GetFileName.getUploadFileName(count);
      return response;
    };


    doS3Upload = async (files, fileIds, entity) => {
      const response = await S3Uploads.uploadFiles(files, fileIds.filename, entity);
      return response;
    };

    showMaintenanceForm = (workorder) => {
      const { user } = this.props;
      if (workorder.status === WORKORDER_STATUS_NEW || workorder.status === WORKORDER_STATUS_INPROGRESS) {
        if (workorder.assigned_role) {
          const havingRole = user.roles.filter(e => (e.id === workorder.assigned_role.id));
          if (havingRole.length > 0) return true;
        }
        if (workorder.assigned_users.length > 0) {
          const checkUser = workorder.assigned_users[0].id === user.id;
          const SystemAdmin = user.roles.filter(e => (e.name === 'System Admin'));
          if (SystemAdmin.length > 0) return true;
          return checkUser;
        }
        const SystemAdmin = user.roles.filter(e => (e.name === 'System Admin'));
        if (SystemAdmin.length > 0) return true;
        return false;
      }
      return false;
    }

    async sendResponse() {
      const {
        actionSendMaintenance,
        leaseWorkorder } = this.props;
      const {
        maintenance,
        answers,
        fieldErrors } = this.state;
      const data = maintenance;
      const noErrors = Object.keys(fieldErrors)
        .every(k => (fieldErrors[k] === false));
      if (noErrors) {
        const aux = { ...data };
        this.setState({
          loadingStatus: true
        });
        const { completed_by, attachments, completed_on, work_description, ...response } = aux;
        const toSend = {};
        toSend.completed_by = completed_by.id;
        toSend.completed_on = completed_on;
        toSend.attachments = attachments;
        toSend.response = JSON.stringify(response);
        toSend.work_description = work_description;

        if (Object.keys(answers)?.length > 0) {
          toSend.response = JSON.stringify({ ...response, ...answers });
        }

        // transform data into formData
        const formData = new FormData();
        let fileIds = '';
        if (data.attachments.length > 0) {
          fileIds = await this.getFileNames(data.attachments.length);
        }
        Object.keys(toSend).forEach((k) => {
          if (k !== 'attachments') {
            formData.append(k, toSend[k]);
          }
        });
        formData.append('email_date', moment().format());
        if (fileIds) {
          await this.doS3Upload(data.attachments, fileIds, 'lease_maintenance')
            .then(() => {
              fileIds.filename.forEach((fileId) => {
                formData.append('attachments', fileId.toString());
              });
            });
        }
        formData.append('report_date', moment(leaseWorkorder.report_date).format());
        actionSendMaintenance(leaseWorkorder.id, formData);
      } else {
        this.setState({ showFormErrors: true });
      }
    }

    //  Redirecting to maintenance list page
    goToMaintenance = () => {
      this.props.history.push('/maintenance');
    }

    handleMultiField = (workorder, response) => {
      let fields = {};
      const multiGridFields = {};
      if (workorder && Object.keys(workorder).length>0) {
        fields = Object.values(workorder).map((item) => {
          if (item.multiple_fields) {
            const multipleFields = Object.fromEntries(
              Object.entries(item.multiple_fields)
                // eslint-disable-next-line no-unused-vars
                .filter(([_, value]) => Object.keys(value).length > 0)
            );
            return { ...item, multiple_fields: multipleFields };
          }
          return item;
        });
      }
      const workOrderResponseMultiFeld = {};
      let workOrderAnswerSchemaMultiFeld = [];
      if (workorder && Object.keys(workorder).length>0 && response && Object.keys(response).length>0) {
        workOrderAnswerSchemaMultiFeld = fields.filter(field => field.type === 'multi_field');
        workorder.forEach((field) => {
          if (field.type === 'multi_field' && response[field.id]) {
            workOrderResponseMultiFeld[field.id] = response[field.id];
          }
        });
      }
      multiGridFields.response = workOrderResponseMultiFeld;
      multiGridFields.schema = workOrderAnswerSchemaMultiFeld;
      return multiGridFields;
    }

    handleWildlifeSpeciesField = (wildlifeField, data) => (
      <div
        key={wildlifeField.id}
        className={customStyles.infoFull}
        style={{ padding: '0', width: '100%', borderBottom: '1px solid #E6EAEE' }}
      >
        <span style={{ borderBottom: '1px solid #E6EAEE', padding: '10px 16px', margin: '0' }}>{wildlifeField.title}</span>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className={`${customStyles.wildLifeFieldsCells} ${customStyles.borderRight}`}>
            <FormattedMessage
              id="wildlife.form.type"
              defaultMessage="Wildlife Type"
            />
            <p style={{ margin: '0' }}>{data[wildlifeField.id]?.type || ''}</p>
          </div>
          <div className={customStyles.wildLifeFieldsCells}>
            <FormattedMessage
              id="wildlife.form.species"
              defaultMessage="Wildlife Species"
            />
            <p style={{ margin: '0' }}>{data[wildlifeField.id]?.species || ''}</p>
          </div>
        </div>
      </div>
    );

    render() {
      const { leaseWorkorder, translations, user } = this.props;
      const { loadingStatus } = this.state;
      const translationMap = translations ? translations[user.language] : {};
      let workOrderFields = {};

      const maintenanceTitle = user?.portal_airport?.airport_settings?.public_nawo_nomenclature?.length > 0
      ? user?.portal_airport?.airport_settings?.public_nawo_nomenclature : 'Maintenance Requests';

      const maintenanceDetails = user?.portal_airport?.airport_settings?.public_nawo_nomenclature?.length > 0
      ? user?.portal_airport?.airport_settings?.public_nawo_nomenclature : '';

      if (leaseWorkorder) {
        workOrderFields = this.handleMultiField(leaseWorkorder?.answer_schema?.fields, leaseWorkorder.response);
      }
      return (
    <>
      {loadingStatus && (<Loading loadingStatus={loadingStatus} />)}
      <SectionHeader icon={icon} translationID="topbar.Maintenance_Requests" defaultTitle={maintenanceTitle} values={{ maintenanceTitle }}>
        <div className={styles.detailHeader}>
          { leaseWorkorder && Object.keys(leaseWorkorder).length > 0
          &&<Status item={leaseWorkorder.status} />
          }
        </div>
      </SectionHeader>
      <HeaderBack
        translationID="inspections.new.prev"
        translationDefault="Back"
        backRoute={'/maintenance'}
      />
      {leaseWorkorder && (
      <div className={styles.panelBottom}>
      <Panel
        containerClasses={styles.mainPanel}
        title={maintenanceDetails ? 'maintenance.detail.header' : 'workorders.detail.header'}
        defaultTitle={maintenanceDetails ? '{maintenanceDetails} {id}' : 'Work Order {id}'}
        translationValues={{ maintenanceDetails, id: leaseWorkorder.order_number }}
      >
        <div className={styles.panelContent}>
          {leaseWorkorder && Object.keys(leaseWorkorder).length > 0 && (
          <WorkorderInfo
            user={user}
            workorder={leaseWorkorder}
            translation={translationMap}
            workOrderFields={workOrderFields}
            handleWildlifeSpeciesField={this.handleWildlifeSpeciesField}
          />
          )}
          {leaseWorkorder && Object.keys(leaseWorkorder).length > 0 && leaseWorkorder.status === WORKORDER_STATUS_CLOSED && (
            <>
            {leaseWorkorder && Object.keys(leaseWorkorder?.maintenance_answer || {}).length > 0 && (
              <MaintenanceReview step="maintenance" info={leaseWorkorder.maintenance_answer}
                handleWildlifeSpeciesField={this.handleWildlifeSpeciesField}
                schema={leaseWorkorder?.maintenance_answer?.answer_schema}
            />
            )}
            {leaseWorkorder && Object.keys(leaseWorkorder?.operations_answer || {}).length > 0 && (
              <OperationReview step="operation" info={leaseWorkorder.operations_answer}
                handleWildlifeSpeciesField={this.handleWildlifeSpeciesField}
                schema={leaseWorkorder?.operations_answer?.operations_answer?.answer_schema}
              />
            )}
            </>
          )}
        </div>
      </Panel>
      </div>
      )}
    </>
      );
    }
}

MaintenanceDetail.defaultProps = {
  userlist: [],
  leaseWorkorder: undefined
};

MaintenanceDetail.propTypes = {
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired,
  actionFetchWorkorder: PropTypes.func.isRequired,
  actionClear: PropTypes.func.isRequired,
  leaseWorkorder: PropTypes.shape({}),
  userlist: PropTypes.shape({})
};

const mapStateToProps = state => ({
  leaseWorkorder: state.lease.leaseWorkorder,
  user: state.auth.profile,
  userlist: state.inspection.userlist,
  translations: state.auth.translations,
  leaseMaintenance_schema: state.lease.leaseMaintenance_schema,
  allDataSources: state.inspection.allDataSources,
  MaintenanceAction: state.lease.MaintenanceAction
});

const mapDispatchToProps = dispatch => ({
  actionFetchWorkorder: (id) => {
    dispatch(getLeaseWorkorder(id));
  },
  actionGetSchemas: () => {
    dispatch(fetchWorkOrderSchema());
  },
  actionSendMaintenance: (id, data) => {
    dispatch(createLeaseMaintenance(id, data));
  },
  actionClear: () => {
    dispatch(clearMaintenance());
  }

});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceDetail);
